var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZapIconActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 27,
    viewBox: "0 0 16 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0548896 14.3213L7.19977 0.273331C7.28507 0.105624 7.45729 0 7.64544 0H14.7781C15.1719 0 15.4111 0.434093 15.2008 0.767026L9.75174 9.39334C9.54143 9.72627 9.78067 10.1604 10.1745 10.1604H14.6047C15.0308 10.1604 15.2616 10.6592 14.9858 10.984L1.73761 26.5835C1.36878 27.0177 0.677015 26.5958 0.894285 26.0691L5.15558 15.7387C5.29135 15.4095 5.04939 15.048 4.69336 15.048H0.500559C0.127368 15.048 -0.114292 14.654 0.0548896 14.3213Z",
    fill: "url(#paint0_linear_7338_4282)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7338_4282",
    x1: 10.1109,
    y1: 6.11043e-10,
    x2: 2.17097,
    y2: 29.0995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD3790"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#248ECC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZapIconActive);
export default __webpack_public_path__ + "static/media/zapIconActive.bb2a0ae4d8c408cb975f9042597cb01e.svg";
export { ForwardRef as ReactComponent };